var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{attrs:{"data":_vm.data,"padding":_vm.padding,"height":_vm.height,"force-fit":true,"onClick":_vm.handleClick}},[_c('v-tooltip'),_c('v-axis'),_c('v-legend'),_c('v-bar',{attrs:{"position":"x*y","color":"type","adjust":_vm.adjust}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }